import { useQuery } from "react-query";
import PrivateApi from "../../services/PrivateApiService";
import SplashPage from "../SplashPage";
import ErrorPage from "../ErrorPage";
import { Container, Row, Col } from "react-bootstrap";
import TimelinesContainer from "../../components/test/TimelinesContainer";

const TimelinePage = () => {

    const API = new PrivateApi();

    // Query calls
    const { data, error, isLoading } = useQuery("TIMELINE", API.client_timeline, { staleTime: Infinity });

    if (isLoading) return <SplashPage />;
    if (error) return <ErrorPage error={error} />;

    return (
        <Container>
            <Row>
                <Col>
                    <h3>Ihre Anlagen bei <span className="text-energo">ENERGO</span> im Zeitverlauf</h3>
                    <p className="text-muted">
                        Diese Ansicht zeigt all Ihre Anlagen und die entsprechenden Energielieferverträge in chronologischer Reihenfolge.
                    </p>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col>
                    <TimelinesContainer data={data.data} />
                </Col>
            </Row>
        </Container>
    );
}
export default TimelinePage;